import React from 'react';
import { Sparkles } from 'lucide-react';
import VideoCard from './VideoCard';

const ConversationMessage = ({ suggestion }) => {
  if (!suggestion) return null;

  const hasVideos = suggestion.video_recommendations?.length > 0;

  return (
    <div
      className="max-w-2xl"
      data-testid={`conversation-msg-${suggestion.suggestion_id}`}
    >
      {/* AI avatar + title */}
      <div className="flex items-center gap-2 mb-2">
        <div className="w-7 h-7 rounded-full bg-sage-light flex items-center justify-center flex-shrink-0">
          <Sparkles size={14} className="text-sage" />
        </div>
        <span className="text-sm font-medium text-charcoal">{suggestion.title}</span>
      </div>

      {/* Description as flowing text */}
      <div className="ml-9 space-y-3">
        <div className="bg-white rounded-xl rounded-tl-sm px-4 py-3 border border-beige shadow-sm">
          <p className="text-sm text-charcoal leading-relaxed whitespace-pre-line">
            {suggestion.description}
          </p>
        </div>

        {/* Video recommendations */}
        {hasVideos && (
          <div>
            <p className="text-xs text-gray-soft uppercase tracking-wide mb-2 flex items-center gap-1.5 ml-1">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="text-red-500">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/>
                <path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white"/>
              </svg>
              See these tutorials
            </p>
            <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
              {suggestion.video_recommendations.map((video, idx) => (
                <VideoCard key={video.video_id || idx} video={video} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationMessage;
